import manifest_45route_45rule from "/tmp/tmpfsi82xy0/node_modules/.pnpm/nuxt@3.15.0_@parcel+watcher@2.5.0_@types+node@20.17.10_db0@0.2.1_eslint@8.57.1_ioredis@5.4.2__vkr3micca2o57bob5zq3fpj3am/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  manifest_45route_45rule
]
export const namedMiddleware = {}